import React, { useState } from 'react';
import { array, func } from 'prop-types';

import MaterialTable from 'material-table';
import Tooltip from '@material-ui/core/Tooltip';

import SensorsTableRowMenu from './SensorsTableRowMenu';

import BobModal from '../../components/BobModal';

import classes from './SensorsTable.module.css';
import { isNil } from 'lodash';

import BobConfirmButton from '../../components/BobConfirmButton';
import BobCancelButton from '../../components/BobCancelButton';
import TextField from '@material-ui/core/TextField';

import {withRouter} from 'react-router';
import { connect } from 'react-redux';

import * as ArchitectActions from '../../actions/architectActions';

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const SensorsTable = ({
    isFullArchitectAllowed,
    sensors,
    onSort,
    onToggleDeleteSensorModal,
    onToggleEditSensorModal,
    onTogglePreviewDataModal,
    order,
    orderBy,
    resetCalculatedSensor,
    selectedNode,
    updateSensor,
    ...props
}) => {

    const [resetCalculationModalOpen, setResetCalculationModalOpen] = useState(false);
    const [resetCalculationEntity, setResetCalculationEntity] = useState({});
    const [startValue, setStartValue] = useState(0);

    const sensorTypeSorter = (a, b) => {
        const valueA = a.sensorType.name.toUpperCase();
        const valueB = b.sensorType.name.toUpperCase();

        if (valueA < valueB) {
            return -1;
        }
        if (valueA > valueB) {
            return 1;
        }

        return 0;
    };

    const renderName = rowData => {
        if (rowData.agentId !== EMPTY_GUID) {
            const { agentName, deviceName, deviceObjectName } = rowData.linkedSource;
            return (
                <React.Fragment>
                    <Tooltip
                        title={
                            <span className={classes.tooltip}>
                                {`${agentName} / ${deviceName} / ${deviceObjectName}`}
                            </span>
                        }
                        placement="top-start"
                    >
                        <img
                            className={classes.linkedIcons}
                            src="/assets/images/linkedIcon.svg"
                            alt="linked-icon"
                        />
                    </Tooltip>
                    <span className={classes.name}>{rowData.name}</span>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <Tooltip
                    title={
                        <span className={classes.tooltip}>
                            {rowData.calculatedSensor ? 'Calculated Sensor' : 'No Object Linked' }
                        </span>
                    }
                    placement="top-start"
                >
                    <img
                        className={classes.linkedIcons}
                        src="/assets/images/unlinkedIcon.svg"
                        alt="unlinked-icon"
                    />
                </Tooltip>
                <span className={classes.name}>{rowData.name}</span>
            </React.Fragment>
        );
    };

    const renderSensorType = rowData => {
        return rowData.sensorType.name;
    };

    const renderSource = rowData => {
        const { agentName, deviceName, deviceObjectName } = rowData.linkedSource;
        const { calculatedSensor } = rowData;

        if (calculatedSensor) {
            return 'Calculation';
        } else if (!isNil(agentName) && !isNil(deviceName) && !isNil(deviceObjectName)) {
            return `${agentName} / ${deviceName} / ${deviceObjectName}`;
        }
        else {
            return 'Not linked';
        }
    };

    const onResetCalculation = async rowData => {
        const options = {resetcalculatedsensor: true};
        await resetCalculatedSensor(rowData.id, options);
    };

    const onResetCalculationModal = (entityData) => {
        setResetCalculationModalOpen(true);
        setResetCalculationEntity(entityData);
    };

    const startValueChange = e => {
        setStartValue(e.target.value);
    };

    const updateSensorRunTime = async () => {
        let payload = {
            ...resetCalculationEntity,
            runtimeHours: Number(startValue)
        };
        const options = {resetcalculatedsensor: true};
        
        const parents = selectedNode.parent.split('/');
        const siteId = parents[parents.length - 2];

        await updateSensor(payload.id, selectedNode.id, siteId, {}, payload, options);
        setResetCalculationModalOpen(false);
    };
    
    const renderMenu = rowData => {
        const { calculatedSensor, sensorType } = rowData;
        const isRuntime = sensorType.name.toLowerCase().includes('total runtime');

        return (
            <SensorsTableRowMenu
                sensor={rowData}
                calculatedSensor={calculatedSensor}
                isRuntimeCalculation={calculatedSensor && isRuntime}
                hidden={!isFullArchitectAllowed}
                onToggleDeleteSensorModal={onToggleDeleteSensorModal}
                onToggleEditSensorModal={onToggleEditSensorModal}
                onTogglePreviewDataModal={onTogglePreviewDataModal}
                onResetCalculation={(rowData) => {onResetCalculation(rowData);}}
                onResetCalculationModal={(rowData) => {onResetCalculationModal(rowData);}}
            />
        );
    };

    return (
        <div className={classes.SensorTable}>
            <MaterialTable
                options={{
                    paging:    false,
                    showTitle: false,
                    search:    false,
                    selection: false,
                    toolbar:   false,
                    sorting:   true
                }}
                columns={[
                    {
                        title:       'Name',
                        field:       'name',
                        defaultSort: 'asc',
                        render:      rowData => renderName(rowData),
                    },
                    {
                        title:      'Sensor Type',
                        customSort: sensorTypeSorter,
                        render:     rowData => renderSensorType(rowData)
                    },
                    {
                        title: 'Display Units',
                        field: 'displayUnit'
                    },
                    {
                        title:  'Source',
                        render: rowData => renderSource(rowData)
                    },
                    {
                        title:  '',
                        render: rowData => renderMenu(rowData)
                    }
                ]}
                data={sensors}
            />
            {
                resetCalculationModalOpen ?
                    <BobModal
                        title={'Runtime'}
                        hidebuttons={true}
                        isRemoveFooter={true}
                        onClose={() => {
                            setResetCalculationModalOpen(false);
                            setStartValue(0);
                        }}
                    >
                        <React.Fragment>
                            <div className={classes.FormField}>
                                <TextField
                                    id="startValue"
                                    name="startValue"
                                    type="number"
                                    variant={'outlined'}
                                    size="small"
                                    label={<span>Start Value <span className={classes.Required}> *</span></span>}
                                    value={startValue}
                                    onChange={(e) => startValueChange(e)}
                                    inputProps={{
                                        min: 0
                                    }}
                                />
                            </div>
                            <BobCancelButton
                                className={classes.Buttons}
                                onClick={() => {
                                    setResetCalculationModalOpen(false);
                                    setStartValue(0);
                                }}
                                label={'Cancel'}
                            />
                            <BobConfirmButton
                                className={classes.Buttons}
                                disabled={startValue && startValue >= 0 ? false : true}
                                onClick={() => updateSensorRunTime()}
                                label={'Update'}
                                iconSize={15}
                            />
                        </React.Fragment>
                    </BobModal> : ''
            }
        </div>
    );
};

SensorsTable.defaultProps = {
    sensors:                   [],
    onSort:                    () => { },
    onResetCalculation:        () => {},
    onToggleDeleteSensorModal: () => {},
    onToggleEditSensorModal:   () => {},
    onTogglePreviewDataModal:  () => {}
};

SensorsTable.propTypes = {
    sensors:                   array.isRequired,
    onResetCalculation:        func,
    onToggleDeleteSensorModal: func,
    onToggleEditSensorModal:   func,
    onTogglePreviewDataModal:  func,
    onSort:                    func
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default withRouter(connect(null, mapDispatchToProps)(SensorsTable));
